export default __webpack_public_path__ + "static/media/sc1.202b35fe.png";